import { Features } from "@iloq/shared/IRootState";
import VueContext from "./vueContext";
import React, { PropsWithChildren, ReactElement, useContext } from "react";

export default function FeatureGuard({
  feature,
  children,
}: PropsWithChildren<{
  feature: string;
}>): ReactElement | null {
  const {
    $store: {
      state: { features },
    },
  } = useContext(VueContext);

  if (features?.[feature as unknown as keyof Features] === false) {
    return <></>;
  }
  return <>{children}</>;
}
